/**
 * API key_source values for the primary care Key Source column.
 */
export enum KeySource {
  CHAT = "chat",
  OCR = "ocr",
  BOTH = "both",
  CONFLICT = "conflict",
  MANUAL = "manual",
  MISSING = "missing",
}

/** Display labels for each KeySource value in the table tag column. */
export const KeySourceLabels: Record<KeySource, string> = {
  [KeySource.CHAT]: "Chat",
  [KeySource.OCR]: "OCR",
  [KeySource.BOTH]: "Both",
  [KeySource.CONFLICT]: "Conflict",
  [KeySource.MANUAL]: "Manual",
  [KeySource.MISSING]: "Missing",
};
